export default "__VITE_ASSET__BraY1RgZ__"